// Close Video on Home Page
$("a#closevid").click(function(){
    $('#embed').remove();
    $('.video-container').addClass("collapsed");
    $('.video-container').removeClass("expanded");
    $( "#video-play" ).css({"opacity":"1"});
    $( ".design-workspace" ).css({"display":"block"});
    $(this).css({"opacity":"0"});
});

// Expand Video Container on Click

$( "#video-play" ).click(function() {
  $( ".video-container" ).html(
    "<div id='embed' class='embed-responsive embed-responsive-16by9'>"+
      "<iframe class='embed-responsive-item' src='//www.youtube.com/embed/YWVenVrga7k?rel=0&autoplay=1' allowfullscreen></iframe>"+
    "</div>"
  );
  $('.video-container').removeClass("collapsed");
  $( ".video-container" ).addClass("expanded");
  $( "#video-play" ).css({"opacity":"0"});
  $( ".design-workspace" ).css({"display":"none"});
  $("#closevid").css({"opacity":"1"});
});


////////////////////////////
// Smooth Scroll to Hash
////////////////////////////

$(document).ready(function(){
  // Add smooth scrolling to all links
  $("a").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});

////////////////////////////
// Scroll To Top
////////////////////////////
(function($) {
    $(document).ready(function(){
 
        //When distance from top = 250px fade button in/out
        $(window).scroll(function(){
            if ($(this).scrollTop() > 250) {
                $('#scrollup').fadeIn(300);
            } else {
                $('#scrollup').fadeOut(300);
            }
        });
 
        //On click scroll to top of page t = 1000ms
        $('#scrollup').click(function(){
            $("html, body").animate({ scrollTop: 0 }, 500);
            return false;
        });
 
    });
})(jQuery);


////////////////////////////
// Safari Detect
////////////////////////////
(function($){
    // console.log(navigator.userAgent);
    /* Adjustments for Safari on Mac */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        // console.log('Safari on Mac detected, applying class...');
        $('html').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
    }
})(jQuery);
